export { default } from "@/components/prizes/prizes2021/Prizes2021Page";
